import Immutable from "immutable";
import { Features } from "resourceModels/Client";
import { getResource } from "selectors/resources";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class AdaMessengerMessageRecord
 * @augments BaseMessageRecord
 */
class AdaMessengerMessageRecord extends BaseMessageRecord({
  type: "ada_messenger_handoff",

  /**
   * @memberof AdaMessengerMessageRecord#
   */
  fallbackResponseId: null,
  tags: ""
}) {
  static blockConfig = state => ({
    isVisible: getResource(state, "client").hasFeature(Features.ADA_MESSENGER),
    icon: "AdaMessenger",
    blockName: "Ada Messenger",
    blockTitle: "Ada Messenger",
    shortTitle: "Ada Messenger",
    blockType: "action"
  })
}

/**
 * Validation
 */

/**
 * @param {AdaMessengerMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
AdaMessengerMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.fallbackResponseId) {
    invalidFields.add("fallbackResponseId");
  }

  return Immutable.List(invalidFields);
};

export default AdaMessengerMessageRecord;
